const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/synedra.ts';
import { actionLoadSynedraToken, LOAD_SYNEDRA_TOKEN } from 'App/actions/synedra';
import { PatAppStoreState } from './setup/rootReducer';
import { getData, makeReducer2, useRemoteData2 } from '@cistec/common_web/utils/redux4Requests';
import { createSelector } from 'reselect';

export const synedraTokenReducer = makeReducer2([[LOAD_SYNEDRA_TOKEN]]);

const selectReducerState = (state: PatAppStoreState) => state.synedraToken;

const selectSynedraToken = createSelector([selectReducerState], (state): { iFrameUrl: string } => getData(state));

export const useSynedraToken = () => {
    return useRemoteData2('synedraToken', {
        request: dispatch => dispatch(actionLoadSynedraToken()),
        select: selectSynedraToken,
    });
};
